<div class="monitor">

  <div class="state-msg" *ngIf="loading()">{{ 'pilotage.pilotage.states.loading' | translate }}</div>
  <div class="state-msg state-error" *ngIf="error() && !loading()">{{ 'pilotage.pilotage.states.error' | translate }}</div>

  <div class="state-empty" *ngIf="!loading() && !error() && establishments().length === 0">
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="1.5">
      <path d="M5 12.55a11 11 0 0 1 14.08 0"/>
      <path d="M1.42 9a16 16 0 0 1 21.16 0"/>
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
      <line x1="12" y1="20" x2="12.01" y2="20"/>
    </svg>
    <p>{{ 'pilotage.pilotage.states.emptyTitle' | translate }}</p>
    <p class="empty-hint" [innerHTML]="'pilotage.pilotage.states.emptyHint' | translate"></p>
  </div>

  <ng-container *ngIf="!loading() && !error() && establishments().length > 0">

    <!-- ── Header ── -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="header-title">{{ 'pilotage.pilotage.header.title' | translate }}</h1>
        <span class="header-date">{{ currentDate() }}</span>
      </div>
      <div class="header-right">
        <div class="header-search" *ngIf="showSearch() && viewMode() === 'grid'">
          <svg class="header-search-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input
            type="text"
            class="header-search-input"
            [placeholder]="'pilotage.pilotage.header.searchPlaceholder' | translate"
            [value]="searchQuery()"
            (input)="searchQuery.set($any($event.target).value)">
        </div>
        <div class="header-chips">
          <button class="chip chip-fluide"   [class.chip-active]="activeFilter() === 'fluide'"   *ngIf="fluidCount()    > 0" (click)="toggleFilter('fluide')">{{ 'pilotage.pilotage.header.chipFluid' | translate: { count: fluidCount() } }}</button>
          <button class="chip chip-tension"  [class.chip-active]="activeFilter() === 'tension'"  *ngIf="tensionCount()  > 0" (click)="toggleFilter('tension')">{{ 'pilotage.pilotage.header.chipModerate' | translate: { count: tensionCount() } }}</button>
          <button class="chip chip-critique" [class.chip-active]="activeFilter() === 'critique'" *ngIf="critiqueCount() > 0" (click)="toggleFilter('critique')">{{ 'pilotage.pilotage.header.chipHigh' | translate: { count: critiqueCount(), status: (statusLabel('critique') | lowercase) } }}</button>
        </div>
        <!-- Toggle vue -->
        <div class="view-toggle-group" role="group" [attr.aria-label]="'pilotage.pilotage.header.viewModeAriaLabel' | translate">
          <button class="view-toggle-btn" [class.active]="viewMode() === 'grid'" (click)="setViewMode('grid')" [title]="'pilotage.pilotage.header.viewGrid' | translate">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
          </button>
          <button class="view-toggle-btn" [class.active]="viewMode() === 'list'" (click)="setViewMode('list')" [title]="'pilotage.pilotage.header.viewList' | translate">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>

    <!-- ── Légende statuts ── -->
    <div class="status-legend">
      <span class="legend-item">
        <span class="legend-dot legend-dot-g"></span>
        {{ 'pilotage.pilotage.status.fluid' | translate }} <span class="legend-range">{{ 'pilotage.pilotage.legend.fluidRange' | translate: { low: legendThresholds().low } }}</span>
      </span>
      <span class="legend-item">
        <span class="legend-dot legend-dot-o"></span>
        {{ statusLabel('tension') }} <span class="legend-range">{{ 'pilotage.pilotage.legend.moderateRange' | translate: { low: legendThresholds().low + 1, high: legendThresholds().high } }}</span>
      </span>
      <span class="legend-item">
        <span class="legend-dot legend-dot-r"></span>
        {{ statusLabel('critique') }} <span class="legend-range">{{ 'pilotage.pilotage.legend.highRange' | translate: { high: legendThresholds().high } }}</span>
      </span>
    </div>

    <!-- ══ VUE CARDS ══ -->
    <div class="sites-grid" *ngIf="viewMode() === 'grid'">
      <ng-container *ngFor="let e of displayedEstablishments(); trackBy: trackById">
      <div class="site-card"
           [class.card-tension]="getStatus(e) === 'tension' && e.isOpen"
           [class.card-critique]="getStatus(e) === 'critique' && e.isOpen"
           [class.card-closed]="!e.isOpen"
           (click)="goToEtablissement(e)">

        <div class="site-bar"
             [class.bar-g]="getStatus(e) === 'fluide' && e.isOpen"
             [class.bar-o]="getStatus(e) === 'tension' && e.isOpen"
             [class.bar-r]="getStatus(e) === 'critique' && e.isOpen"
             [class.bar-mu]="getStatus(e) === 'no-data' || !e.isOpen"></div>

        <div class="site-body">
          <div class="site-name-row">
            <span class="site-name">{{ e.name }}</span>
          </div>

          <div class="site-hours">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span *ngIf="e.todayHours">{{ e.todayHours }}</span>
            <span *ngIf="!e.todayHours">{{ 'pilotage.pilotage.card.closedToday' | translate }}</span>
          </div>

          <div class="site-closed-label" *ngIf="!e.isOpen">{{ 'pilotage.pilotage.card.closed' | translate }}</div>

          <div class="site-ok" *ngIf="getStatus(e) === 'fluide' && e.isOpen">● {{ statusLabel('fluide') }}</div>

          <div class="site-status-row" *ngIf="getStatus(e) === 'tension' && e.isOpen">
            <span class="status-tension">⚡ {{ statusLabel('tension') }}</span>
          </div>

          <div class="site-status-row" *ngIf="getStatus(e) === 'critique' && e.isOpen">
            <span class="status-dot-r"></span>
            <span class="status-critique">{{ statusLabel('critique') }}</span>
          </div>

          <div class="site-no-data" *ngIf="getStatus(e) === 'no-data' && e.isOpen">{{ 'pilotage.pilotage.card.noData' | translate }}</div>

          <div class="site-attente" *ngIf="getDataSource(e) === 'sensor' && e.isOpen">
            {{ 'pilotage.pilotage.card.estimatedPresenceLabel' | translate }} <strong>{{ 'pilotage.pilotage.card.peopleCount' | translate: { count: e.currentOccupancy } }}</strong>
          </div>

          <div class="site-flux" *ngIf="getDataSource(e) === 'sensor' && e.isOpen">
            <span class="flux-in">↓ {{ 'pilotage.pilotage.card.entriesCount' | translate: { count: e.totalInToday } }}</span>
            <span class="flux-out">↑ {{ 'pilotage.pilotage.card.exitsCount' | translate: { count: e.totalOutToday } }}</span>
          </div>

          <!-- Temps d'attente -->
          <div class="site-wait" *ngIf="e.isOpen && isManual(e)">
            {{ 'pilotage.pilotage.card.waitLabel' | translate }}
            <span class="wait-badge" [class.wait-badge-r]="getStatus(e) === 'critique'">{{ getManualWaitMinutes(e) }} min</span>
            <span class="wait-queue-label" *ngIf="e.queueName">· {{ e.queueName }}</span>
          </div>
          <div class="site-wait" *ngIf="e.isOpen && isBaseline(e)">
            <span class="wait-label">{{ 'pilotage.pilotage.card.handlingLabel' | translate }}</span>
            <span class="wait-badge" [class.wait-badge-r]="getStatus(e) === 'critique'">{{ getBaselineWaitMinutes(e) }} min</span>
          </div>
          <div class="site-wait" *ngIf="e.isOpen && !isManual(e) && !isBaseline(e) && getWaitTime(e) != null">
            <span class="wait-label">{{ 'pilotage.pilotage.card.handlingLabel' | translate }}</span>
            <span class="wait-badge" [class.wait-badge-r]="getStatus(e) === 'critique'">{{ getWaitTime(e) }} min</span>
          </div>

          <div class="site-timeline">
            <div class="tl-entry" *ngFor="let slot of getTimelineSlots(e); let i = index">
              <span class="tl-time">{{ slot }}</span>
              <span class="tl-dot"
                    [class.tl-vert]="getTimelineDotColor(e, i) === 'green'"
                    [class.tl-orange]="getTimelineDotColor(e, i) === 'orange'"
                    [class.tl-rouge]="getTimelineDotColor(e, i) === 'red'"
                    [class.tl-inactive]="getTimelineDotColor(e, i) === 'inactive'"></span>
              <span class="tl-minutes">{{ getTimelineMinutes(e, i) != null ? getTimelineMinutes(e, i) + ' min' : '—' }}</span>
            </div>
          </div>
        </div>
      </div>
      </ng-container>
    </div>

    <!-- ══ VUE LISTE ══ -->
    <div class="sites-list" *ngIf="viewMode() === 'list'">

      <!-- En-tête colonnes -->
      <div class="list-header">
        <span class="lh-bar"></span>
        <span class="lh-col lh-name">
          <ng-container *ngIf="!searchOpen() || !showSearch()">
            {{ 'pilotage.pilotage.list.siteColumn' | translate }}
            <button class="search-icon-btn" *ngIf="showSearch()" (click)="searchOpen.set(true)" [title]="'pilotage.pilotage.list.filterBySiteName' | translate">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </button>
          </ng-container>
          <span class="search-inline" *ngIf="searchOpen() && showSearch()">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="search-input" type="text" [placeholder]="'pilotage.pilotage.list.filterPlaceholder' | translate" [value]="searchQuery()"
                   (input)="searchQuery.set($any($event.target).value)"
                   (keydown.escape)="closeSearch()" autofocus>
            <button class="search-clear-btn" (click)="closeSearch()">×</button>
          </span>
        </span>
        <span class="lh-col lh-hours">{{ 'pilotage.pilotage.list.hoursColumn' | translate }}</span>
        <span class="lh-col lh-status">{{ 'pilotage.pilotage.list.statusColumn' | translate }}</span>
        <span class="lh-col lh-presence">{{ 'pilotage.pilotage.list.presenceColumn' | translate }}</span>
        <span class="lh-col lh-in">{{ 'pilotage.pilotage.list.entriesColumn' | translate }}</span>
        <span class="lh-col lh-out">{{ 'pilotage.pilotage.list.exitsColumn' | translate }}</span>
        <span class="lh-col lh-wait">{{ 'pilotage.pilotage.card.handlingLabel' | translate }}</span>
        <span class="lh-col lh-timeline">{{ 'pilotage.pilotage.list.trafficColumn' | translate }}</span>
      </div>

      <!-- Aucun résultat de recherche -->
      <div class="search-empty" *ngIf="searchQuery() && displayedEstablishments().length === 0">
        {{ 'pilotage.pilotage.list.noSearchResults' | translate: { query: searchQuery() } }}
      </div>

      <ng-container *ngFor="let e of displayedEstablishments(); trackBy: trackById; let i = index">

        <!-- Séparateur de groupe entre sévérités (désactivé si recherche active) -->
        <div class="list-group-sep"
             *ngIf="!searchQuery() && i > 0 && e.isOpen && displayedEstablishments()[i - 1].isOpen && getStatus(e) !== getStatus(displayedEstablishments()[i - 1])">
          <span class="group-sep-label">{{ getStatus(e) === 'no-data' ? ('pilotage.pilotage.list.noData' | translate) : statusLabel(getStatus(e)) }}</span>
        </div>

        <div class="list-row"
             [class.list-row-tension]="getStatus(e) === 'tension' && e.isOpen"
             [class.list-row-critique]="getStatus(e) === 'critique' && e.isOpen"
             [class.list-row-closed]="!e.isOpen"
             (click)="goToEtablissement(e)">

          <!-- Barre couleur -->
          <span class="list-bar"
                [class.bar-g]="getStatus(e) === 'fluide' && e.isOpen"
                [class.bar-o]="getStatus(e) === 'tension' && e.isOpen"
                [class.bar-r]="getStatus(e) === 'critique' && e.isOpen"
                [class.bar-mu]="!e.isOpen || getStatus(e) === 'no-data'"></span>

          <!-- Nom -->
          <span class="list-name-col">
            <span class="list-name">{{ e.name }}</span>
          </span>

          <!-- Horaires du jour -->
          <span class="list-hours">
            <span *ngIf="e.todayHours">{{ e.todayHours }}</span>
            <span class="wait-none" *ngIf="!e.todayHours">{{ 'pilotage.pilotage.card.closed' | translate }}</span>
          </span>

          <!-- Statut pill -->
          <span class="list-status">
            <span class="status-pill pill-fluide"   *ngIf="getStatus(e) === 'fluide' && e.isOpen"><span class="pill-dot"></span>{{ statusLabel('fluide') }}</span>
            <span class="status-pill pill-tension"  *ngIf="getStatus(e) === 'tension' && e.isOpen">⚡ {{ statusLabel('tension') }}</span>
            <span class="status-pill pill-critique" *ngIf="getStatus(e) === 'critique' && e.isOpen"><span class="pill-dot dot-pulse"></span>{{ statusLabel('critique') }}</span>
            <span class="status-pill pill-closed"   *ngIf="!e.isOpen">{{ 'pilotage.pilotage.card.closed' | translate }}</span>
          </span>

          <!-- Présence / Entrées / Sorties : fusionnées en un seul indicateur discret quand le site n'a pas de capteur -->
          <ng-container *ngIf="e.isOpen && getDataSource(e) === 'sensor'; else noSensorCols">
            <span class="list-num">
              <span class="num-val">{{ e.currentOccupancy }}</span>
              <span class="num-unit">{{ 'pilotage.pilotage.list.peopleUnit' | translate }}</span>
            </span>
            <span class="list-num">
              <span class="num-val num-in">{{ e.totalInToday }}</span>
            </span>
            <span class="list-num">
              <span class="num-val num-out">{{ e.totalOutToday }}</span>
            </span>
          </ng-container>
          <ng-template #noSensorCols>
            <span class="list-no-sensor">{{ e.isOpen ? ('pilotage.pilotage.list.noSensor' | translate) : '—' }}</span>
          </ng-template>

          <!-- Attente -->
          <span class="list-wait">
            <ng-container *ngIf="e.isOpen && isManual(e)">
              <span class="wait-badge" [class.wait-badge-r]="getStatus(e) === 'critique'" [title]="e.queueName ?? ''">{{ getManualWaitMinutes(e) }} min</span>
            </ng-container>
            <ng-container *ngIf="e.isOpen && !isManual(e) && isBaseline(e)">
              <span class="wait-badge" [class.wait-badge-r]="getStatus(e) === 'critique'">{{ getBaselineWaitMinutes(e) }} min</span>
            </ng-container>
            <ng-container *ngIf="e.isOpen && !isManual(e) && !isBaseline(e)">
              <span class="wait-badge" *ngIf="getWaitTime(e) as wait"
                    [class.wait-badge-r]="getStatus(e) === 'critique'">{{ wait }} min</span>
              <span class="wait-none" *ngIf="!getWaitTime(e)">—</span>
            </ng-container>
            <span class="wait-none" *ngIf="!e.isOpen">—</span>
          </span>

          <!-- Timeline dots -->
          <span class="list-timeline">
            <span class="tl-dot"
                  *ngFor="let slot of getTimelineSlots(e); let i = index"
                  [class.tl-vert]="!e.isOpen ? false : getTimelineDotColor(e, i) === 'green'"
                  [class.tl-orange]="!e.isOpen ? false : getTimelineDotColor(e, i) === 'orange'"
                  [class.tl-rouge]="!e.isOpen ? false : getTimelineDotColor(e, i) === 'red'"
                  [class.tl-inactive]="!e.isOpen || getTimelineDotColor(e, i) === 'inactive'"></span>
          </span>

        </div>
      </ng-container>
    </div>

  </ng-container>

</div>
